import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-primary"
}

import { computed, inject, provide } from 'vue';
import { v4 as uuid } from 'uuid';
import get from 'lodash/get';

import NvStack from '@/core/components/layout/Stack/NkStack.vue';

import {
  FormExposition, formInjectionKey,
  formItemInjectionKey,
  formItemProps as propsDefinition,
} from './form.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkFormItem',
  props: propsDefinition,
  setup(__props) {

const props = __props

const id = uuid();


const injection = inject(formInjectionKey) as FormExposition;
const validator = computed(() => injection?.validator.value);
const validatorField = computed(() => get(validator.value, props?.prop || ''));
const errors = computed(() => validatorField.value?.$errors || []);
const error = computed(() => validatorField.value?.$error);
const isRequired = computed(() => validatorField.value?.required);

provide(formItemInjectionKey, {
  id,
  error,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NvStack, { spacing: 1 }, {
    default: _withCtx(() => [
      (_ctx.$props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _unref(id)
          }, [
            _createTextVNode(_toDisplayString(_ctx.$props.label) + " ", 1),
            (_unref(isRequired))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " *"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_unref(error))
        ? (_openBlock(), _createBlock(NvStack, {
            key: 1,
            spacing: 1
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "text-xxs text-danger"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})